import { AlarmStatus } from '@core/models/alarm-status.model';
import { Alarm, SearchAlarmResults } from '@core/models/alarm.model';
import { Thresholds } from '@core/models/threshold.model';
import { createReducer, on } from '@ngrx/store';

import { AlarmHelper } from '../helpers/alarm.helper';
import { AlarmsFilters } from '../models/alarms-filters.model';
import { AlarmsSortBy } from '../models/alarms-sorting.model';

import * as AlarmsActions from './alarms.actions';

export const alarmsFeatureKey = 'alarms';

export interface State {
  loading: boolean;
  selectedTab: AlarmStatus;
  alarms: SearchAlarmResults;
  selectedAlarms: Array<Alarm>;
  thresholds: Thresholds;
  filters: AlarmsFilters;
  currentPage: number;
  sortBy: AlarmsSortBy;
  checkAll: boolean;
}

const initialState: State = {
  loading: true,
  selectedTab: AlarmStatus.OPEN,
  alarms: { totalCount: 0, results: [] },
  selectedAlarms: [],
  thresholds: null,
  filters: {
    simulationType: null,
    measureSource: null,
    attribute: null,
    thresholdType: null,
    state: 'all'
  },
  currentPage: 1,
  sortBy: { sort: 'time', order: 'ASC' },
  checkAll: false
};

export const reducer = createReducer(
  initialState,
  on(AlarmsActions.selectTab, (state, { tab }) => ({
    ...state,
    selectedTab: tab,
    selectedAlarms: [],
    loading: true,
    currentPage: 1,
    alarms: { totalCount: 0, results: [] },
    checkAll: false
  })),
  on(AlarmsActions.switchAlarmsStatus, (state, { newStatus }) => ({ ...state, loading: true })),
  on(AlarmsActions.setThresholdsAttributeList, (state, { thresholds }) => ({ ...state, thresholds })),
  on(AlarmsActions.updateFilters, (state, { filters }) => ({
    ...state,
    filters,
    selectedAlarms: [],
    loading: true,
    currentPage: 1,
    alarms: { totalCount: 0, results: [] }
  })),
  on(AlarmsActions.updateSortBy, (state, { sortBy }) => ({ ...state, sortBy, loading: true, currentPage: 1 })),
  on(AlarmsActions.updateAlarmsList, (state, { alarms }) => ({
    ...state,
    alarms,
    selectedAlarms: state.checkAll ? alarms.results : state.selectedAlarms,
    loading: false
  })),
  on(AlarmsActions.updateAlarm, (state, { alarm }) => ({
    ...state,
    alarms: {
      totalCount: state.alarms.totalCount,
      results: state.alarms.results.map(a => (AlarmHelper.isSameAlarms(a, alarm) ? alarm : a))
    }
  })),
  on(AlarmsActions.updateSelectedAlarm, (state, { selectedAlarm }) => {
    const isRemoving = state.selectedAlarms.some(a => AlarmHelper.isSameAlarms(a, selectedAlarm));
    return {
      ...state,
      selectedAlarms: !isRemoving
        ? [...state.selectedAlarms, selectedAlarm]
        : state.selectedAlarms.filter(a => !AlarmHelper.isSameAlarms(a, selectedAlarm))
    };
  }),
  on(AlarmsActions.nextPage, state => ({
    ...state,
    currentPage: state.currentPage + 1,
    loading: true
  })),
  on(AlarmsActions.previousPage, state => ({
    ...state,
    currentPage: state.currentPage - 1,
    loading: true
  })),
  on(AlarmsActions.checkCurrentPage, state => ({
    ...state,
    selectedAlarms: state.alarms.results,
    checkAll: false
  })),
  on(AlarmsActions.checkAll, state => ({
    ...state,
    selectedAlarms: [],
    checkAll: true
  })),
  on(AlarmsActions.uncheckAll, state => ({
    ...state,
    selectedAlarms: [],
    checkAll: false
  }))
);
